import React from "react";

import Logo from "../Assets/buyist.png";
import { useEffect, useState } from "react";
import Searchbar from "../SearchBar/searchbar";
import { FiShoppingBag, FiBookmark } from "react-icons/fi";
import { useCart } from "../Context/cartcontext";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";

const Header = () => {
  const { cartState } = useCart();

  const [privateData, setPrivateData] = useState("");
  const history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem("authToken")) {
      history.push("/auth/login");
    }

    const fetchPrivateDate = async () => {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      };

      try {
        const { data } = await axios.get(
          "https://buyist-server.herokuapp.com/api/private",
          config
        );
        setPrivateData(data.data);
        console.log(privateData);
      } catch (error) {
        console.log("You are not authorized please login");
      }
    };

    fetchPrivateDate();
  });

  return (
    <div className="bg-white sticky top-0 z-50 w-full mx-auto border-t border-gray flex-shrink-0 shadow-md h-14 flex p-9 text-3xl sm:w-full md-full">
      <div className="w-full flex items-center justify-between">
        <span href="" className="justify-center items-center flex">
          <Link to="">
            <div className="hidden sm:block ">
              <img src={Logo} alt="logo" style={{ height: "12vh" }} />
            </div>
          </Link>
        </span>
        <div className="flex p-6 space-x-6 justify-center items-center ">
          <div>
            <Link to="/shop">
              <button className="hidden sm:block text-2xl p-2 w-full focus:text-blue-500 focus:outline-none font-extrabold">
                Shop!
              </button>
            </Link>
          </div>
          <div className="sm:text-2xl">
            <Searchbar />
          </div>
          <div className="sm:text-2xl relative inline-block">
            <Link to="/wishlist">
              <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-yellow-500 rounded-full">
                {cartState.wishlist.length}
              </span>
              <FiBookmark />
            </Link>
          </div>
          <div className="sm:text-2xl relative inline-block">
            <Link to="/cart">
              <FiShoppingBag />
              <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-yellow-500 rounded-full">
                {cartState.cart.length}
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
